/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import actions from '../action/helpDeskAction'

export const initialState = ({
  loading: false,
  ticketList: [],
  orderList: [],
})


export default function (state = initialState, action) {
  switch (action.type) {

    case actions.TYPES.REQUEST_TICKET:
      return Object.assign({}, state, { ticketList: action.payload, loading: true})

    case actions.TYPES.REQUEST_TICKET_SUCCESS:
      return Object.assign({}, state, { ticketList: action.payload, loading: false})

    case actions.TYPES.UPDATE_TICKET_LIST:
      return Object.assign({}, state, { ticketList: action.payload})

    case actions.TYPES.REQUEST_REQUESTED_ORDER:
      return Object.assign({}, state, { orderList: [], loading: true})

    case actions.TYPES.REQUEST_REQUESTED_ORDER_SUCCESS:
      return Object.assign({}, state, { orderList: action.payload, loading: false})

    case actions.TYPES.REMOVE_REQUESTED_ORDER__FROM_LIST:
      const ticket = action.payload.item;
      //const newList = state.ticketList.
      const newList = state.orderList
      if(newList == null || newList == undefined) return Object.assign({}, state, {loading: false});
      newList.data = newList.data.filter(item => {
        if(item.id != ticket.id) return item
      })

      return Object.assign({}, state, { orderList: newList, loading: false})

    default:
      return state
  }
}
